import { AuditLogRepository, SecurityLog } from '../ports/AuditLogRepository';

export class CreateSecurityLogUseCase {
  constructor(private repository: AuditLogRepository) {}

  async execute(ownerId: string, log: SecurityLog): Promise<string> {
    if (!ownerId) throw new Error('OwnerId is required for security logging');
    return await this.repository.createSecurityLog(ownerId, log);
  }
}
